<template>
  <div>
    <div v-if="category" class="border-b-2 border-[#FF7352] my-4 sm:my-6">
      <div class="flex">
        <OLink class="flex grow-0 ml-3" :href="getCategoryPath">
          <div class="bg-[#FF7352] rounded-t-md p-3">
            <OIcon :icon="getIconPath(category.name)" svg-class="w-6 h-6 text-white" />
          </div>
          <h1 class="text-[#FF7352] uppercase font-bold text-lg leading-5 my-auto pl-4">{{ category.name }}</h1>
        </OLink>
      </div>
    </div>
    <div class="flex justify-center sm:justify-between flex-col sm:flex-row sm:space-x-6">
      <div class="w-full mr-0 space-y-4 sm:space-y-6">
        <VitrinArticleCard
          v-for="(article, index) in feed.articles"
          :key="article._id"
          :article="article"
          :data-layer="
            category ? { name: `Vitrin - Tümü - ${category.name}`, position: index + 1 } : { name: 'Vitrin - Tümü', position: index + 1 }
          "
        />
      </div>

      <div v-if="!isMobile" class="space-y-6">
        <VitrinPromotionCard v-for="article in feed.promotions" :key="article._id" :item="article" />
      </div>

      <div v-else>
        <VitrinCarousel v-if="feed.promotions.length" :articles="promotions" class="mt-4" :class="{ 'mb-16': feed.promotions.length > 1 }">
          <SwiperSlide v-for="article in promotions" :key="article.id">
            <VitrinPromotionCard :item="article" />
          </SwiperSlide>
        </VitrinCarousel>
      </div>
    </div>
    <div v-if="category" class="flex justify-center mt-6 mb-5">
      <OLink class="flex flex-row items-center" :href="getCategoryPath">
        <span class="text-[#FF7352] font-semibold text-md leading-16 tracking-tight pr-2">TÜMÜNÜ GÖR</span>
        <div class="bg-[#FF7352] rounded-full p-2">
          <img style="width: 12px; height: 12px" src="/svg/right-white.svg" alt="" />
        </div>
      </OLink>
    </div>
  </div>
</template>
<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import VitrinCarousel from '~/modules/vitrin/components/VitrinCarousel';
import { useDevice } from '~/composables/useDevice';
import VitrinArticleCard from '~/modules/vitrin/components/VitrinArticleCard';
import VitrinPromotionCard from '~/modules/vitrin/components/VitrinPromotionCard';
import VitrinCarouselArticle from '~/modules/vitrin/components/VitrinCarouselArticle';
import { normalizeText } from '~/modules/common/utils/stringUtils';
import { OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    VitrinArticleCard,
    VitrinPromotionCard,
    VitrinCarouselArticle,
    VitrinCarousel,
    SwiperSlide,
    OLink,
    OIcon,
  },
  props: {
    category: {
      type: Object,
    },
    feed: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const getIconPath = (name) => `vitrin/icons/${normalizeText(name)}`;

    const getCategoryPath = computed(() => `/vitrin/${normalizeText(props.category.name)}`);
    const promotions = computed(() => props.feed.promotions.slice(0, 5));

    return { isMobile, getCategoryPath, promotions, getIconPath };
  },
});
</script>
